import { styled } from "@mui/material/styles";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, FlexColumn, FlexRow, FlexRowCenter, SearchTextField } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ChannelsList from "./ChannelsList";
import LoadingMSTeams from "./LoadingMSTeams";
import { useMSTeamsStore } from "./MSTeamsStore";

const PREFIX = "ChannelSelection";

const classes = {
	action: `${PREFIX}action`,
};

const StyledFlexColumn = styled(FlexColumn)(({
	theme,
}) => ({
	[`& .${classes.action}`]: {
		borderTop: STANDARD_BORDER_STYLE,
		padding: theme.spacing(2, 3),
		width: "100%",
	},
}));

const ConnectButton = observer(() => {
	const {
		connectAndNavigateToChannelDisplay,
		selectedChannel,
	} = useMSTeamsStore();

	return (
		<Button
			design="primary"
			disabled={!selectedChannel}
			fullWidth
			onClick={connectAndNavigateToChannelDisplay}
			res="Connect"
		/>
	);
});

const ChannelSelection: FunctionComponent = observer(() => {
	const {
		closeRightPane,
		disconnectedPublicChannels,
		navigationToAddChannel,
		onChangeText,
		backToConnectedChannels,
		readyToDisplayPublicChannelsWithTeamNames,
	} = useMSTeamsStore();
	const loc = useLocale();

	const loading = !readyToDisplayPublicChannelsWithTeamNames;

	return (
		<StyledFlexColumn>
			<FlexRowCenter>
				<PaneHeader
					back
					onBack={backToConnectedChannels}
					onClose={closeRightPane}
					titleRes="SelectChannel"
				/>
			</FlexRowCenter>
			<FlexRow
				alignItems={loading ? "center" : "start"}
				flexGrow={1}
				justifyContent="center"
				overflow="auto"
			>
				{loading ?
					<LoadingMSTeams />
					: (
						<FlexColumn flexGrow={1} style={{ height: "100%", maxWidth: "100%" }}>
							<Box
								borderBottom={STANDARD_BORDER_STYLE}
								px={3}
								py={2}
							>
								<SearchTextField
									fullWidth
									onChange={onChangeText}
									placeholder={loc.resource("SearchByChannelName")}
								/>
							</Box>
							<Box p={2}>
								<Button
									design="link"
									onClick={navigationToAddChannel}
									res="AddNewChannelTitle"
									startIcon={<AddCircleIcon />}
								/>
							</Box>
							<Box
								flexGrow={1}
								height={1}
								overflow="auto scroll"
							>
								<ChannelsList
									publicChannels={disconnectedPublicChannels}
									showRadio
								/>
							</Box>
							<Box className={classes.action}>
								<ConnectButton />
							</Box>
						</FlexColumn>
					)}
			</FlexRow>
		</StyledFlexColumn>
	);
});

export default ChannelSelection;